$(document).ready(function () {
var sizeMap = {
  '28A': 'AA',
  '30A': 'AA',
  '32A': 'AA',
  '28B': 'AA',
  '30B': 'AA',
  '28C': 'AA',
  '34A': 'A',
  '28D': 'A',
  '30C': 'A',
  '32B': 'A',
  '36A': 'B',
  '34B': 'B',
  '32C': 'B',
  '30D': 'B',
  '28DD/E': 'B',
  '38A': 'C',
  '36B': 'C',
  '34C': 'C',
  '32D': 'C',
  '30DD/E': 'C',
  '28DDD/F': 'C',
  '40A': 'D',
  '38B': 'D',
  '36C': 'D',
  '34D': 'D',
  '32DD/E': 'D',
  '30DDD/F': 'D',
  '28G': 'D',
  '42A': 'E',
  '40B': 'E',
  '38C': 'E',
  '36D': 'E',
  '34DD/E': 'E',
  '32DDD/F': 'E',
  '30G': 'E',
  '28H': 'E',
  '44A': 'F',
  '42B': 'F',
  '40C': 'F',
  '38D': 'F',
  '36DD/E': 'F',
  '34DDD/F': 'F',
  '32G': 'F',
  '30H': 'F',
  '28I': 'F',
  '44B': 'G',
  '42C': 'G',
  '40D': 'G',
  '38DD/E': 'G',
  '36DDD/F': 'G',
  '34G': 'G',
  '32H': 'G',
  '30I': 'G',
  '28J': 'G',
  '44C': 'H',
  '42D': 'H',
  '40DD/E': 'H',
  '38DDD/F': 'H',
  '36G': 'H',
  '34H': 'H',
  '32I': 'H',
  '30J': 'H',
  '28K': 'H',
  '44D': 'I',
  '42DD/E': 'I',
  '40DDD/F': 'I',
  '38G': 'I',
  '36H': 'I',
  '34I': 'I',
  '32J': 'I',
  '30K': 'I',
  '28L': 'I',
  '44DD/E': 'J',
  '42DDD/F': 'J',
  '40G': 'J',
  '38H': 'J',
  '36I': 'J',
  '34J': 'J',
  '32K': 'J',
  '30L': 'J',
  '28M': 'J',
  '44DDD/F': 'K',
  '42G': 'K',
  '40H': 'K',
  '38I': 'K',
  '36J': 'K',
  '34K': 'K',
  '32L': 'K',
  '30M': 'K',
  '28N': 'K',
  '44G': 'L',
  '42H': 'L',
  '40I': 'L',
  '38J': 'L',
  '36K': 'L',
  '34L': 'L',
  '32M': 'L',
  '30N': 'L',
  '28O': 'L',
  '44H': 'M',
  '42I': 'M',
  '40J': 'M',
  '38K': 'M',
  '36L': 'M',
  '34M': 'M',
  '32N': 'M',
  '30O': 'M',
  '28P': 'M',
};

// Combined variant mapping
  var combinedVariantMap = {
  'Beige-AA': '43825637064880',
  'Beige-A': '43825637195952',
  'Beige-B': '43825637327024',
  'Beige-C': '43825637458096',
  'Beige-D': '43825637589168',
  'Beige-E': '43825637720240',
  'Beige-F': '43825637851312',
  'Beige-G': '43825637982384',
  'Beige-H': '43825638113456',
  'Beige-I': '43825638244528',
  'Beige-J': '43847758512304',
  'Beige-K': '43847758643376',
  'Beige-L': '43867850440880',
  'Beige-M': '43867850571952',
  'Sand-AA': '43825637097648',
  'Sand-A': '43825637228720',
  'Sand-B': '43825637359792',
  'Sand-C': '43825637490864',
  'Sand-D': '43825637621936',
  'Sand-E': '43825637753008',
  'Sand-F': '43825637884080',
  'Sand-G': '43825638015152',
  'Sand-H': '43825638146224',
  'Sand-I': '43825638277296',
  'Sand-J': '43847758545072',
  'Sand-K': '43847758676144',
  'Sand-L': '43867850473648',
  'Sand-M': '43867850604720',
  'Caramel-AA': '43825637130416',
  'Caramel-A': '43825637261488',
  'Caramel-B': '43825637392560',
  'Caramel-C': '43825637523632',
  'Caramel-D': '43825637654704',
  'Caramel-E': '43825637785776',
  'Caramel-F': '43825637916848',
  'Caramel-G': '43825638047920',
  'Caramel-H': '43825638178992',
  'Caramel-I': '43825638310064',
  'Caramel-J': '43847758577840',
  'Caramel-K': '43847758708912',
  'Caramel-L': '43867850506416',
  'Caramel-M': '43867850637488',
  'Cocoa-AA': '43825637163184',
  'Cocoa-A': '43825637294256',
  'Cocoa-B': '43825637425328',
  'Cocoa-C': '43825637556400',
  'Cocoa-D': '43825637687472',
  'Cocoa-E': '43825637818544',
  'Cocoa-F': '43825637949616',
  'Cocoa-G': '43825638080688',
  'Cocoa-H': '43825638211760',
  'Cocoa-I': '43825638342832',
  'Cocoa-J': '43847758610608',
  'Cocoa-K': '43847758741680',
  'Cocoa-L': '43867850539184',
  'Cocoa-M': '43867850670256',
};
  
var sizeSelected = false;

$('.band-container-var input[type="radio"]').on('click', function() {
  $('.band-container-var input[type="radio"]').removeClass('active-radio');
  $(this).addClass('active-radio');
  sizeSelected = true;
  updateSizeSelection();
});

$('.cup-container-var input[type="radio"]').on('click', function() {
  $('.cup-container-var input[type="radio"]').removeClass('active-radio');
  $(this).addClass('active-radio');
  sizeSelected = true;
  updateSizeSelection();
});

function getCurrentColor() {
  var colorInput = $('input[name="Color"]:checked');
  return colorInput.length ? colorInput.val() : null;
}

function getCurrentSizeValue() {
  const selectedBand = $('input[name="varaint-band"]:checked').val();
  const selectedCup = $('input[name="varaint-cup"]:checked').val();
  if (selectedBand && selectedCup) {
    const sizeKey = selectedBand + selectedCup;
    return sizeMap[sizeKey];
  }
  return null;
}

function updateSizeDisplay(sizeValue) {
  $('.is-style-size span[update-value]').text(sizeValue || '');
}

function updateVariantUrl(sizeValue) {
  const color = getCurrentColor();
  if (!color || !sizeValue) return;

  const variantKey = color + '-' + sizeValue;
  const variantId = combinedVariantMap[variantKey];

  if (variantId) {
    const newUrl = window.location.pathname + '?variant=' + variantId;
    history.replaceState(null, null, newUrl);
    $('input[name="id"]').val(variantId);

    if (typeof Shopify !== 'undefined' && Shopify.updateProductVariant) {
      Shopify.updateProductVariant(variantId);
    }
  }
}

function updateColorSwatchesAvailability(sizeValue) {
  const currentColor = getCurrentColor();
  let foundValidColor = false;

  $('input[name="Color"]').each(function () {
    const $input = $(this);
    const color = $input.val();
    const variantKey = color + '-' + sizeValue;
    const $label = $('label[for="' + $input.attr('id') + '"]');

    if (combinedVariantMap[variantKey]) {
      $input.prop('disabled', false).removeClass('is-disabled');
      $label.removeClass('unavailable');
      if (color === currentColor) foundValidColor = true;
    } else {
      $input.prop('disabled', true).addClass('is-disabled');
      $label.addClass('unavailable');
    }
  });

  // if (!foundValidColor) {
  //   const $first = $('input[name="Color"]:not(.is-disabled)').first();
  //   if ($first.length) {
  //     $first.prop('checked', true).trigger('change');
  //   }
  // }
}

function updateSizeSelection() {
  const sizeValue = getCurrentSizeValue();
  if (!sizeValue) return;

  updateColorSwatchesAvailability(sizeValue);
  updateSizeDisplay(sizeValue);
  updateVariantUrl(sizeValue);

  const $sizeInput = $('input[name="Size"][value="' + sizeValue + '"]');
  if ($sizeInput.length) {
    $sizeInput.prop('checked', true);
  }

}

$('.band-container-var input[type="radio"]').on('change', function() {
  $('.band-container-var input[type="radio"]').removeClass('active-radio');
  $(this).addClass('active-radio');
  updateSizeSelection();
});

$('.cup-container-var input[type="radio"]').on('change', function() {
  $('.cup-container-var input[type="radio"]').removeClass('active-radio');
  $(this).addClass('active-radio');
  updateSizeSelection();
});

$('input[name="Color"]').on('change', function () {
  updateVariantUrl(getCurrentSizeValue());
});

$(document).ready(function () {
  updateSizeSelection();
});



  
  
$('input[name="varaint-band"]').on('click', function() {
        const selectedBand1 = $(this).val();

        $('.varaint-item.cup-container-var').removeClass('hide-cup');

        if (selectedBand1 === '44') {
            $('input[name="varaint-cup"][value="I"], input[name="varaint-cup"][value="J"], input[name="varaint-cup"][value="K"], input[name="varaint-cup"][value="L"], input[name="varaint-cup"][value="M"], input[name="varaint-cup"][value="N"], input[name="varaint-cup"][value="O"], input[name="varaint-cup"][value="P"]')
                .closest('.varaint-item')
                .addClass('hide-cup');
        } else if (selectedBand1 === '42') {
            $('input[name="varaint-cup"][value="J"], input[name="varaint-cup"][value="K"], input[name="varaint-cup"][value="L"], input[name="varaint-cup"][value="M"], input[name="varaint-cup"][value="N"], input[name="varaint-cup"][value="O"], input[name="varaint-cup"][value="P"]')
                .closest('.varaint-item')
                .addClass('hide-cup');
        } else if (selectedBand1 === '40') {
            $('input[name="varaint-cup"][value="K"], input[name="varaint-cup"][value="L"], input[name="varaint-cup"][value="M"], input[name="varaint-cup"][value="N"], input[name="varaint-cup"][value="O"], input[name="varaint-cup"][value="P"]')
                .closest('.varaint-item')
                .addClass('hide-cup');
        } else if (selectedBand1 === '38') {
            $('input[name="varaint-cup"][value="L"], input[name="varaint-cup"][value="M"], input[name="varaint-cup"][value="N"], input[name="varaint-cup"][value="O"], input[name="varaint-cup"][value="P"]')
                .closest('.varaint-item')
                .addClass('hide-cup');
        } else if (selectedBand1 === '36') {
            $('input[name="varaint-cup"][value="M"], input[name="varaint-cup"][value="N"], input[name="varaint-cup"][value="O"], input[name="varaint-cup"][value="P"]')
                .closest('.varaint-item')
                .addClass('hide-cup');
        } else if (selectedBand1 === '34') {
            $('input[name="varaint-cup"][value="N"], input[name="varaint-cup"][value="O"], input[name="varaint-cup"][value="P"]')
                .closest('.varaint-item')
                .addClass('hide-cup');
        } else if (selectedBand1 === '32') {
            $('input[name="varaint-cup"][value="O"], input[name="varaint-cup"][value="P"]')
                .closest('.varaint-item')
                .addClass('hide-cup');
        } else if (selectedBand1 === '30') {
            $('input[name="varaint-cup"][value="P"]')
                .closest('.varaint-item')
                .addClass('hide-cup');
        }
    });

    $('input[name="varaint-cup"]').on('click', function() {
        const selectedCup1 = $(this).val();

        // Show all band options first
        $('.varaint-item.band-container-var').removeClass('hide-band');

        // Hide the band options based on the selected cup
        if (selectedCup1 === 'P') {
            $('input[name="varaint-band"][value="30"], input[name="varaint-band"][value="32"], input[name="varaint-band"][value="34"], input[name="varaint-band"][value="36"], input[name="varaint-band"][value="38"], input[name="varaint-band"][value="40"], input[name="varaint-band"][value="42"], input[name="varaint-band"][value="44"]')
                .closest('.varaint-item')
                .addClass('hide-band');
        } else if (selectedCup1 === 'O') {
            $('input[name="varaint-band"][value="32"], input[name="varaint-band"][value="34"], input[name="varaint-band"][value="36"], input[name="varaint-band"][value="38"], input[name="varaint-band"][value="40"], input[name="varaint-band"][value="42"], input[name="varaint-band"][value="44"]')
                .closest('.varaint-item')
                .addClass('hide-band');
        } else if (selectedCup1 === 'N') {
            $('input[name="varaint-band"][value="34"], input[name="varaint-band"][value="36"], input[name="varaint-band"][value="38"], input[name="varaint-band"][value="40"], input[name="varaint-band"][value="42"], input[name="varaint-band"][value="44"]')
                .closest('.varaint-item')
                .addClass('hide-band');
        } else if (selectedCup1 === 'M') {
            $('input[name="varaint-band"][value="36"], input[name="varaint-band"][value="38"], input[name="varaint-band"][value="40"], input[name="varaint-band"][value="42"], input[name="varaint-band"][value="44"]')
                .closest('.varaint-item')
                .addClass('hide-band');
        } else if (selectedCup1 === 'L') {
            $('input[name="varaint-band"][value="38"], input[name="varaint-band"][value="40"], input[name="varaint-band"][value="42"], input[name="varaint-band"][value="44"]')
                .closest('.varaint-item')
                .addClass('hide-band');
        } else if (selectedCup1 === 'K') {
            $('input[name="varaint-band"][value="40"], input[name="varaint-band"][value="42"], input[name="varaint-band"][value="44"]')
                .closest('.varaint-item')
                .addClass('hide-band');
        } else if (selectedCup1 === 'J') {
            $('input[name="varaint-band"][value="42"], input[name="varaint-band"][value="44"]')
                .closest('.varaint-item')
                .addClass('hide-band');
        } else if (selectedCup1 === 'I') {
            $('input[name="varaint-band"][value="44"]')
                .closest('.varaint-item')
                .addClass('hide-band');
        }
    });
    
});